import { render, staticRenderFns } from "./DashboardUserSumut.vue?vue&type=template&id=334e2ce3&lang=pug"
import script from "./DashboardUserSumut.vue?vue&type=script&lang=js"
export * from "./DashboardUserSumut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports